import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  const isMobile = windowWidth <= 768;
  const isUltraSmall = windowWidth < 400;

  React.useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  const footerStyle = {
    background: '#8b4513',
    color: 'white',
    padding: isMobile ? '0.15rem 0.1rem 0.15rem' : '0.46rem 0.23rem 0.23rem', // Smaller mobile padding
    marginTop: 'auto',
    borderTop: '1px solid #6b3410'
    // REMOVED: height constraints that cut off content
  };

  const footerContentStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: isMobile ? '0.05rem' : '0.23rem' // Small but visible gap
    // REMOVED: height constraints that interfere with content visibility
  };

  const linksContainerStyle = {
    display: 'flex',
    gap: isUltraSmall ? '0.4rem' : (isMobile ? '0.5rem' : '1.4rem'),
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginBottom: isMobile ? '0.05rem' : '0.23rem', // Small but reasonable margin below links
    alignItems: 'center'
  };

  const linkStyle = {
    color: 'white',
    textDecoration: 'none',
    fontSize: isUltraSmall ? '0.75rem' : (isMobile ? '0.8rem' : '0.78rem'),
    transition: 'opacity 0.3s',
    padding: '0',
    lineHeight: '1'
  };

  const copyrightStyle = {
    textAlign: 'center',
    fontSize: isMobile ? '0.7rem' : '0.68rem', // MUCH smaller mobile for proportion (0.25rem → 0.15rem), desktop unchanged
    color: '#f5e6d3',
    borderTop: isMobile ? 'none' : '1px solid rgba(255,255,255,0.15)',
    paddingTop: isMobile ? '0' : '0.23rem', // ORIGINAL: 0.23rem desktop
    marginTop: isMobile ? '0.05rem' : '0.23rem', // Small mobile margin, original desktop
    width: '100%',
    lineHeight: isMobile ? '1.2' : '1.4', // Readable mobile, original desktop
    paddingBottom: isMobile ? '0.15rem' : '0', // Enough space for text to show, original desktop
    // Tutorial page protection ONLY on mobile
    ...(isMobile && {
      fontFamily: 'system-ui, -apple-system, sans-serif !important',
      fontWeight: 'normal !important',
      fontSize: '0.7rem',
      lineHeight: '1.2 !important', // Readable line height
      color: '#f5e6d3 !important',
      textAlign: 'center !important'
    })
  };

  return (
    <footer style={footerStyle}>
      <div style={footerContentStyle}>
        <div style={linksContainerStyle}>
          <Link to="/terms" style={linkStyle} onMouseOver={(e) => e.target.style.opacity = '0.8'} onMouseOut={(e) => e.target.style.opacity = '1'}>
            Terms of Service
          </Link>
          <Link to="/privacy" style={linkStyle} onMouseOver={(e) => e.target.style.opacity = '0.8'} onMouseOut={(e) => e.target.style.opacity = '1'}>
            Privacy Policy
          </Link>
          <a href="mailto:support@mygnology.com" style={linkStyle} onMouseOver={(e) => e.target.style.opacity = '0.8'} onMouseOut={(e) => e.target.style.opacity = '1'}>
            Support
          </a>
        </div>
        
        <div style={copyrightStyle}>
          <p style={{
            margin: '0', 
            fontSize: isMobile ? '0.7rem' : '0.68rem', // Proportionally smaller mobile, original desktop
            lineHeight: '1.4', // ORIGINAL: 1.4 for all
            // Tutorial page protection ONLY on mobile - desktop gets NO overrides
            ...(isMobile && {
              lineHeight: '1.2 !important', // Readable mobile line height
              fontFamily: 'system-ui, -apple-system, sans-serif !important',
              fontWeight: 'normal !important',
              color: '#f5e6d3 !important',
              fontSize: '0.7rem',
              textAlign: 'center !important'
            })
          }}>
            © {new Date().getFullYear()} Gene and GNology. All rights reserved.
          </p>
          <p style={{
            margin: '0.15rem 0 0',
            fontSize: isMobile ? '0.7rem' : '0.68rem',
            lineHeight: '1.4',
            color: '#f5e6d3',
            letterSpacing: '0.02em'
          }}>
            Built by <span style={{ fontWeight: 600, color: '#ffffff' }}>MindStreams Technology</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
